"use strict";

var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("./utils");

var Resource =
/*#__PURE__*/
function () {
  function Resource(resource) {
    _classCallCheck(this, Resource);

    this.resource = resource;
    this.resource = resource;
    this.timestamp = utils_1.now();
    this.deferred = utils_1.defer();
  }

  _createClass(Resource, [{
    key: "resolve",
    value: function resolve() {
      this.deferred.resolve(undefined);
      return new Resource(this.resource);
    }
  }, {
    key: "promise",
    get: function get() {
      return this.deferred.promise;
    }
  }]);

  return Resource;
}();

exports.Resource = Resource;